import { PAYMENT_TYPES } from '../types/orders';

export const paymentMethodLabelsValue = [
  { name: 'Transferencia MXN', value: PAYMENT_TYPES.TRANSFER_MXN },
  { name: 'Tarjeta de crédito MXN', value: PAYMENT_TYPES.CARD_MXN },
  { name: 'Transferencia USD', value: PAYMENT_TYPES.TRANSFER_USD },
  { name: 'Tarjeta de crédito USD', value: PAYMENT_TYPES.INTERNATIONAL_CARD },
  { name: 'Transferencia COP', value: PAYMENT_TYPES.TRANSFER_COP },
  { name: 'Tarjeta de crédito COP', value: PAYMENT_TYPES.CARD_COP },
  { name: 'Transferencia PEN', value: PAYMENT_TYPES.TRANSFER_PEN },
  { name: 'Transferencia ARS', value: PAYMENT_TYPES.TRANSFER_ARS },
  { name: 'Transferencia CLP', value: PAYMENT_TYPES.TRANSFER_CLP },
  { name: 'Transferencia BRL', value: PAYMENT_TYPES.TRANSFER_BRL },
  { name: 'Crédito Bord MXN', value: PAYMENT_TYPES.BORD_CREDIT_MXN },
  { name: 'Crédito Bord USD', value: PAYMENT_TYPES.BORD_CREDIT_USD },
  { name: 'Crédito Bord COP', value: PAYMENT_TYPES.BORD_CREDIT_COP },
  { name: 'Crédito Bord PEN', value: PAYMENT_TYPES.BORD_CREDIT_PEN },
  { name: 'Crédito Bord ARS', value: PAYMENT_TYPES.BORD_CREDIT_ARS },
  { name: 'Crédito Bord CLP', value: PAYMENT_TYPES.BORD_CREDIT_CLP },
  { name: 'Crédito Bord BRL', value: PAYMENT_TYPES.BORD_CREDIT_BRL }
];

export const typeFilterRawOptionsValueAndName = [
  { name: 'garantías', value: 'warranty' },
  { name: 'diagnósticos', value: 'diagnostic' },
  { name: 'Buy & Hold', value: 'buyAndHold' },
  { name: 'onboarding', value: 'onboarding' },
  { name: 'offboarding', value: 'offboarding' },
  { name: 'reasignaciones', value: 'relocate' }
];

export const monthFilterRawOptions = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre'
];
